var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    {
      '--color-white': _vm.color === _vm.COLORS.WHITE,
      '--color-light-grey': _vm.color === _vm.COLORS.LIGHT_GREY,
      '--color-grey': _vm.color === _vm.COLORS.GREY,
      '--color-black': _vm.color === _vm.COLORS.BLACK,
      '--color-brand': _vm.color === _vm.COLORS.BRAND
    },
    'icon__detail d-flex align-items-center'
  ]},[(_vm.icon)?_c('v-icon',{attrs:{"icon":_vm.icon,"size":"1.5rem"}}):_c('div',{staticClass:"placeholder icon-placeholder"}),(_vm.content)?_c('span',{staticClass:"ml-1 d-flex align-items-end"},[_vm._v(" "+_vm._s(_vm.content)+" "),_c('h6',[_vm._v(_vm._s(_vm.subContent))])]):_c('div',{staticClass:"placeholder content-placeholder"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }